export default "__VITE_ASSET__CqpX4AFS__"